import { Component, SimpleChanges, ViewChild } from '@angular/core';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';
import { SubSink } from 'subsink';
import {MatSort, Sort, MatSortModule} from '@angular/material/sort';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
  selector: 'app-preview-section',
  templateUrl: './preview-section.component.html',
  styleUrls: ['./preview-section.component.scss']
})
export class PreviewSectionComponent {

  dataSource:any;


  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
 
  ngOnChanges(changedvals: SimpleChanges){
    
    this.dataSource = new MatTableDataSource(this._tableData[this.page-1]);

    this._fb.nodeConnectionCreated$.subscribe((res:any)=>{
      
    })
    
  }

  okdh(){
    this.dataSource = new MatTableDataSource(this._tableData[this.page-1]);
  }

  

  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort|any) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  graph_color: any = ['#9d9685', '#9d9685', '#9d9685', '#9d9685', '#9d9685'];
  tableKeys:any[]=[];
  page=1;
  selectedPage=5;


  showGraphToggle:boolean = false;
  graphLineData: any = [];

  pageArr=[
    5,10,25
  ];


  subs:SubSink=new SubSink();

  constructor(
    public _fb:FlowBuilderService,
    private _liveAnnouncer: LiveAnnouncer
  ){}

  ngOnInit(){
    if(this._fb.previewData.length>0){
      this.tableKeys =  Object.keys(this._fb.previewData[0]);
    }

    this._fb.graphUpdate$.subscribe((res:any)=>{
      
      this.showGraph('u');
    })

    this.dataSource = new MatTableDataSource(this._tableData[this.page-1]);
    
    
  }

  incriement(){
    if(this._tableData.length>this.page)
    {
      this.page++;
    }
  }
  decriement(){
    if(1<this.page)
    {
      this.page--;
    }
  }

  get _tableKeys(){
    return Object.keys(this._fb.previewData[0]);
  }

  get _tableData(){
    let tb_length= this._fb.previewData?.length;
    let spiltValue = 0;
    let arr:any[]=[];
    let i=0;
    while (tb_length>0) {
      i++
      arr.push(this._fb.previewData.slice(this.selectedPage*(i-1),this.selectedPage*i));
      tb_length -= this.selectedPage;
    }
    return arr;
  }


  showGraph(type?:string) {
    let table_name = "test_data_"+this._fb.timeStamp;
    let request_for = 'line';
    this.subs.add(
      this._fb.getLineGraph(table_name,request_for)
      .subscribe((res:any)=>{
        const line_chart = res?.line;
        this.graphLineData = line_chart;
        this.showGraphToggle = !this.showGraphToggle;
      
      })
    )

  }


  getLineData() {

    let d_data: any = []

    if (this.graphLineData?.line_chart && this.graphLineData.line_chart?.length > 0) {
      this.graphLineData?.line_chart?.forEach((element: { y_data: any; }) => {
        d_data.push(String(element.y_data)?.replace(/\,/g,''))
      });
    }
    return d_data;

  }

 

  getLineLabels() {

    let labels: any = []

    if (this.graphLineData?.line_chart && this.graphLineData?.line_chart?.length > 0) {
      this.graphLineData?.line_chart?.forEach((element: { x_data: string; }) => {
        labels.push(String(element.x_data)?.replace(/\,/g,''))
      });
    }
    return labels;

  }


}
